/**
 * Modal for multiple instruction manual file links. Uses <dialog showModal()>.
 */
(function () {
  function initDialog(dialog) {
    if (dialog.dataset.assemblyManualsInit === '1') return;
    dialog.dataset.assemblyManualsInit = '1';

    const opener = document.querySelector(
      '[data-manuals-modal-open][data-manuals-modal-id="' + dialog.id.replace(/"/g, '\\"') + '"]'
    );

    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', () => {
      opener?.focus();
    });
  }

  function openDialog(dialog) {
    initDialog(dialog);
    if (typeof dialog.showModal !== 'function') return;
    try {
      dialog.showModal();
    } catch {
      return;
    }
    const toFocus = dialog.querySelector('.manuals-modal__link') || dialog.querySelector('[data-manuals-modal-close]');
    toFocus?.focus();
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-manuals-modal-open]');
    if (!opener) return;
    const id = opener.getAttribute('data-manuals-modal-id');
    if (!id) return;
    const dialog = document.getElementById(id);
    if (!dialog || !dialog.classList.contains('manuals-modal__dialog')) return;
    e.preventDefault();
    openDialog(dialog);
  });

  document.addEventListener('click', (e) => {
    const closer = e.target.closest('[data-manuals-modal-close]');
    if (!closer) return;
    const id = closer.getAttribute('data-manuals-modal-id');
    const dialog = id ? document.getElementById(id) : closer.closest('dialog');
    if (dialog && dialog.classList.contains('manuals-modal__dialog')) {
      e.preventDefault();
      dialog.close();
    }
  });

  document.querySelectorAll('dialog.manuals-modal__dialog').forEach((d) => initDialog(d));
})();
